import { io } from 'socket.io-client';
import { SOCKET_URL } from './config';

class SocketManager {
  constructor() {
    this.socket = null;
    this.listeners = new Map();
  }

  connect(userId, token) {
    if (this.socket?.connected) return;

    console.log(`🔌 Attempting to connect socket to ${SOCKET_URL}`);
    this.socket = io(SOCKET_URL, {
      auth: { token },
      query: { userId },
    });

    this.socket.on('connect', () => {
      console.log('✅ Connected to iVivaCore server');
    });

    this.socket.on('disconnect', () => {
      console.log('Disconnected from iVivaCore server');
    });

    this.socket.on('alert', (data) => {
      this.emit('alert', data);
    });

    // Patient private room — vitals pushed to individual patient
    this.socket.on('vitals_update', (data) => {
      this.emit('vitals_update', data);
    });

    // Clinicians room — broadcast from ingestionService.js
    // Added: was missing from original socketManager
    this.socket.on('patient_vitals_sync', (data) => {
      this.emit('patient_vitals_sync', data);
    });

    // Wearable bridge broadcast — from wearableBridge.js vitals_sync emit
    // Added: was missing from original socketManager
    this.socket.on('vitals_sync', (data) => {
      this.emit('vitals_sync', data);
    });

    // AI analysis completion events
    this.socket.on('analysis_complete', (data) => {
      console.log('🧠 AI Analysis Received:', data);
      this.emit('analysis_complete', data);
    });
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }

  on(event, callback) {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set());
    }
    this.listeners.get(event).add(callback);
  }

  off(event, callback) {
    if (this.listeners.has(event)) {
      this.listeners.get(event).delete(callback);
    }
  }

  emit(event, data) {
    if (this.listeners.has(event)) {
      this.listeners.get(event).forEach(callback => callback(data));
    }
  }

  send(event, data) {
    if (this.socket?.connected) {
      this.socket.emit(event, data);
    }
  }
}

export default new SocketManager();